// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from 'vue-router'
import './assets/css/gloable.css'
import "@/utils/flexible";
import request from "@/utils/request"
import VueQuillEditor from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import ElementUI from 'element-ui';
//引入ElementUI的所有样式
import 'element-ui/lib/theme-chalk/index.css';
// import '../src/assets/css/common.css'
// 引入Minxin
import DefaultImgMixin from "@/mixin/defaultImgMixin.js"
Vue.mixin(DefaultImgMixin)
Vue.use(ElementUI)
Vue.prototype.request = request
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VueQuillEditor)
import './utils/flexible'

// console.log=function(){};
// Vue.prototype.$globalVariable = null;


function loadCss(url){
  const link =  document.createElement('link')
  link.rel = 'stylesheet'
  link.type='text/css'
  link.href = url
  document.getElementsByTagName('head')[0].appendChild(link)
 }
 
 var userAgent = window.navigator.userAgent.toLowerCase();
 var isWindows = /win/i.test(userAgent);
 var isMac = /mac/i.test(userAgent);
 
 if (isWindows) {
   console.log("current system:Windows" );
   console.log("加载common.css");
   loadCss('./static/css/common.css')
 } else if (isMac) {
   console.log("current system:Mac" );
   console.log("加载commonMac.css");
  //  import('./assets/css/commonMac.css')
   loadCss('./static/css/commonMac.css')
 }

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js